import { Abstrap } from '../../..';

const { propTypes } = Abstrap;

const defaultProps = { ...Abstrap.defaultProps, componentClass: 'div' };

class FormCompletion extends Abstrap {

    getClassNameSchema() {
        const {
            className,
        } = this.props;
        return [
            'c-form__completion',
            className,
        ];
    }

}

FormCompletion.propTypes = propTypes;

FormCompletion.defaultProps = defaultProps;

export default FormCompletion;
